"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MsgDepositForBurnResponse = exports.MsgDepositForBurn = void 0;
//@ts-nocheck
/* eslint-disable */
const binary_1 = require("../../../binary");
const helpers_1 = require("../../../helpers");
function createBaseMsgDepositForBurn() {
    return {
        from: "",
        amount: "",
        destinationDomain: 0,
        mintRecipient: new Uint8Array(),
        burnToken: ""
    };
}
exports.MsgDepositForBurn = {
    typeUrl: "/circle.cctp.v1.MsgDepositForBurn",
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.from !== "") {
            writer.uint32(10).string(message.from);
        }
        if (message.amount !== "") {
            writer.uint32(18).string(message.amount);
        }
        if (message.destinationDomain !== 0) {
            writer.uint32(24).uint32(message.destinationDomain);
        }
        if (message.mintRecipient.length !== 0) {
            writer.uint32(34).bytes(message.mintRecipient);
        }
        if (message.burnToken !== "") {
            writer.uint32(42).string(message.burnToken);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgDepositForBurn();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.from = reader.string();
                    break;
                case 2:
                    message.amount = reader.string();
                    break;
                case 3:
                    message.destinationDomain = reader.uint32();
                    break;
                case 4:
                    message.mintRecipient = reader.bytes();
                    break;
                case 5:
                    message.burnToken = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e;
        const message = createBaseMsgDepositForBurn();
        message.from = (_a = object.from) !== null && _a !== void 0 ? _a : "";
        message.amount = (_b = object.amount) !== null && _b !== void 0 ? _b : "";
        message.destinationDomain = (_c = object.destinationDomain) !== null && _c !== void 0 ? _c : 0;
        message.mintRecipient = (_d = object.mintRecipient) !== null && _d !== void 0 ? _d : new Uint8Array();
        message.burnToken = (_e = object.burnToken) !== null && _e !== void 0 ? _e : "";
        return message;
    },
    fromAmino(object) {
        const message = createBaseMsgDepositForBurn();
        if (object.from !== undefined && object.from !== null) {
            message.from = object.from;
        }
        if (object.amount !== undefined && object.amount !== null) {
            message.amount = object.amount;
        }
        if (object.destination_domain !== undefined && object.destination_domain !== null) {
            message.destinationDomain = object.destination_domain;
        }
        if (object.mint_recipient !== undefined && object.mint_recipient !== null) {
            message.mintRecipient = (0, helpers_1.bytesFromBase64)(object.mint_recipient);
        }
        if (object.burn_token !== undefined && object.burn_token !== null) {
            message.burnToken = object.burn_token;
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.from = message.from;
        obj.amount = message.amount;
        obj.destination_domain = message.destinationDomain;
        obj.mint_recipient = message.mintRecipient ? (0, helpers_1.base64FromBytes)(message.mintRecipient) : undefined;
        obj.burn_token = message.burnToken;
        return obj;
    },
    fromAminoMsg(object) {
        return exports.MsgDepositForBurn.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return exports.MsgDepositForBurn.decode(message.value);
    },
    toProto(message) {
        return exports.MsgDepositForBurn.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/circle.cctp.v1.MsgDepositForBurn",
            value: exports.MsgDepositForBurn.encode(message).finish()
        };
    }
};
function createBaseMsgDepositForBurnResponse() {
    return {
        nonce: BigInt(0)
    };
}
exports.MsgDepositForBurnResponse = {
    typeUrl: "/circle.cctp.v1.MsgDepositForBurnResponse",
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.nonce !== BigInt(0)) {
            writer.uint32(8).uint64(message.nonce);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseMsgDepositForBurnResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.nonce = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseMsgDepositForBurnResponse();
        message.nonce = object.nonce !== undefined && object.nonce !== null ? BigInt(object.nonce.toString()) : BigInt(0);
        return message;
    },
    fromAmino(object) {
        const message = createBaseMsgDepositForBurnResponse();
        if (object.nonce !== undefined && object.nonce !== null) {
            message.nonce = BigInt(object.nonce);
        }
        return message;
    },
    toAmino(message) {
        const obj = {};
        obj.nonce = message.nonce ? message.nonce.toString() : undefined;
        return obj;
    },
    fromAminoMsg(object) {
        return exports.MsgDepositForBurnResponse.fromAmino(object.value);
    },
    fromProtoMsg(message) {
        return exports.MsgDepositForBurnResponse.decode(message.value);
    },
    toProto(message) {
        return exports.MsgDepositForBurnResponse.encode(message).finish();
    },
    toProtoMsg(message) {
        return {
            typeUrl: "/circle.cctp.v1.MsgDepositForBurnResponse",
            value: exports.MsgDepositForBurnResponse.encode(message).finish()
        };
    }
};
//# sourceMappingURL=tx.js.map